
export default {
    data() {
        return {
            isLoading: false
        };
    },
    methods: {
        globalEncode(model, modelId) {
            if(model && modelId){
                return btoa(`${model}:${modelId}`);
            }

            return  null;
        },

        globalDecode(modelEncode) {
            if(modelEncode){
                let encodeId = atob(modelEncode);
                encodeId = encodeId.split(":");
                return encodeId[1];
            }

            return  null;
        }
    }
};
